import React from 'react';
import { Tag } from 'antd';
import {
  ACTIVATED,
  CANCELED,
  CONCLUDED,
  IGNORED,
  INITIALBALANCE,
  INPROGRESS,
  PAYMENT,
  PENDING,
  RECEIPT,
  RECONCILED
} from 'constants/types';
import display from 'constants/display';

const getColorByType = (type) => {
  switch (type) {
    case RECEIPT:
    case RECONCILED:
    case CONCLUDED:
      return 'green';
    case ACTIVATED:
      return 'blue';
    case PAYMENT:
      return 'red';
    case PENDING:
    case CANCELED:
    case INITIALBALANCE:
      return 'gray';
    case IGNORED:
    case INPROGRESS:
      return 'warning';
    default:
      return '';
  }
};

const StatusOrTypeTag = ({ type, customDisplay = {} }) => {
  return (
    <Tag color={getColorByType(type)}>
      {customDisplay[type] ?? display[type]}
    </Tag>
  );
};

export default StatusOrTypeTag;
